import React from "react";
import { Icon } from "@alm/flow-ds/components";
import { Task } from "records/Task";
import { useTranslation } from "react-i18next";

function PriorityMarker({ priority }: { priority: Task["priority"] }) {
	const { t } = useTranslation();

	return (
		<div className={`task-card__priority--${priority}`}>
			<span className="sr-only">
				{t(`main.tasks.labels.${priority}`)}
			</span>
			{priority === "HIGH" || priority === "LOW" ? (
				<Icon type={priority === "HIGH" ? "arrow-up" : "arrow-down"} />
			) : (
				t("main.text.na")
			)}
		</div>
	);
}

export default PriorityMarker;
